/**
 * WEBVIEW 탭(RN 화면이 없어 `TabWebViewScreen` 으로 렌더되는 탭)의 경로 세그먼트.
 *
 * 값은 서버 mainTabs 의 `tab.id` 와 같게 유지한다 — 네이티브 `ably://main/:tab_id` 가 그 id 로
 * 탭을 찾고(`MainViewModel`: `tabId in tabs.map { it.id }`), 웹은 같은 값을 URL 세그먼트로 쓴다.
 * (`MainTabType` 의 id 들: home / ranking / like / overview / mypage)
 */
export const WEBVIEW_TAB_PATHS: Record<string, string> = {
  TODAY_DELIVERY: 'today_delivery',
  PLACE_HOME: 'place',
  MY_PAGE: 'mypage',
};
